import { IconLayer } from '@deck.gl/layers';

import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { SnAppliance } from '@lib/api/entities';
import { snDetailExpand, snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';
import { FsDeckGLOverlay } from '@lib/geo/helpers';
import { FsMap } from '@lib/geo/map';
import { THEME } from '@lib/ui/theme';

@Component({
  selector: 'sn-compass-device-management-table',
  templateUrl: './compass-device-management-table.component.html',
  styleUrls: ['./compass-device-management-table.component.scss'],
  animations: [snFadeIn, snFadeOut, snDetailExpand],
})
export class CompassDeviceManagementTableComponent
  extends SnTableBaseComponent<SnAppliance>
  implements OnInit
{
  public appliance: SnAppliance;
  private _expanded: any = [];
  private _map: FsMap;
  private _deckOverlay: FsDeckGLOverlay;

  constructor(private readonly _cd: ChangeDetectorRef) {
    super();
  }

  public ngOnInit(): void {}

  public trackBy(index: number, item: any): any {
    return item.id;
  }

  public isExpanded(id: string): boolean {
    return this._expanded.indexOf(id) > -1;
  }

  public toggleExpanded(item: SnAppliance): void {
    this.appliance = item;
    if (this.isExpanded(item.id)) {
      this._expanded = [];
    } else {
      this._expanded = [item.id];
      this._cd.detectChanges();
    }
  }

  public onMapInit(fsMap: FsMap): void {
    const lon = this.appliance.reportMeta.modemMeta.geoStatus.longitude;
    const lat = this.appliance.reportMeta.modemMeta.geoStatus.latitude;
    this._map = fsMap;
    this._map.setCenter([lon, lat]);
    this._createOverlay();
    this._cd.detectChanges();
  }

  public setVoltageIcon(voltage: number): string {
    if (voltage <= 12 && voltage >= 9) {
      return 'fa-battery-full';
    }
    if (voltage <= 9 && voltage >= 6) {
      return 'fa-battery-three-quarters';
    }
    if (voltage < 6) {
      return 'fa-battery-slash';
    }
  }

  public setVoltageStyle(voltage: number): string {
    if (voltage <= 12 && voltage >= 9) {
      return `color: ${THEME.success};`;
    }
    if (voltage <= 9 && voltage >= 6) {
      return 'color: #FFD43B;';
    }
    if (voltage < 6) {
      return 'color: #f4511e;';
    }
  }

  private _createOverlay(): void {
    this._deckOverlay = new FsDeckGLOverlay();

    const cameraIcon = this._createMarker();
    const overlay = this._deckOverlay.addLayer(cameraIcon);
    this._map.addLayer(overlay);
  }

  private _createMarker(): IconLayer {
    return new IconLayer({
      id: `appliance-${this.appliance.id}-icon`,
      data: [this.appliance],
      getIcon: () => ({
        url: '/assets/fusus-icons/PNG/Locations.png',
        width: 128,
        height: 128,
      }),
      getPosition: (appliance: SnAppliance) => [
        Number(appliance.reportMeta.modemMeta.geoStatus.longitude),
        Number(appliance.reportMeta.modemMeta.geoStatus.latitude),
      ],
      getSize: 26,
      pickable: false,
    });
  }
}
